<script>
export default {
  name: "UiCompletionCard",
}
</script>

<template>
  <section 
    data-comp="UiCompletionCard"
    class="border rounded-md px-3 py-2"
  >
    <slot></slot>
  </section>
</template>